import { get } from "lodash";
import axios from "./../utils/axiosConfig";
import { apiFetch } from "../utils/fetchConfig";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
};

export const useIdentityAppService = () => {

    const GetIdentityAppService = {
        getUserByUsername: (username: string) => {
            let url = `/user/by-username/${username}`;
            return axios.get(`${url}`, { headers });
        },

        updateUser: (updateData: any) => {
            let url = `/user/update`;
            return axios.put(`${url}`, updateData, { headers });
        },

        loginAdmin: (username: string, password: string) => {
            let url = `/admin/login`;
            return axios.post(`${url}`, { username, password }, { headers });
        },

        getUserHistory: async (user: any) => {
            let url = `/user/${user.userId}/history`;
            return axios.get(`${url}`, { headers });
        },

        getUserRequests: async (currentUserId: string) => {
            let url = `/user/${currentUserId}/requests`;
            return axios.get(`${url}`, { headers });
        },

        getRequestHistory: async (username: string) => {
            let url = `/request-history/${username}`;
            return axios.get(`${url}`, { headers });
        },

        getRequestLifecycle: async (requestId: any) => {
            let url = `/request-lifecycle/${requestId}`;
            return axios.get(`${url}`, { headers });
        },

        getUserDetails: async (username: string) => {
            let url = `/user/details/${username}`;
            return axios.get(`${url}`, { headers });
        },

        getB2cAuthCode: (authCode: any) => {
            let url = "/auth/b2c/token";
            return axios.post(`${url}`, {}, {
                headers: {
                    'X-B2C-Code': `${authCode}`
                }
            });
        },

        postSessionInfo: () => {
            let url = `/post-signin/session-info`;
            return axios.post(`${url}`, {}, {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: false
            });
        },

        getCodeLookupByType: async () => {
            const url = "/code-lookup/by-type/State%20Dropdown";
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        getCodeLookupByTypeCountryDropdown: async () => {
            const url = "/code-lookup/by-type/Country%20Dropdown";
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        getUserTypes: async () => {
            const url = "/code-lookup/user-types";
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        getOrganizationTypes: async () => {
            const url = "/code-lookup/organization-types";
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        searchOrganizations: async (organizationName: string) => {
            const url = `/organization/search?name=${encodeURIComponent(organizationName)}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        getExternalAccessApplications: async () => {
            const url = `/application/external-access`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
    },

          getInternalAccessWithRoles: async () => {
            const url = `/application/internal-access-with-roles`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

         updateUserSearch: async (body: any) => {
            const url = `/user/search-and-update`;
            return apiFetch(url, { method: "PUT", headers: { 'Content-Type': 'application/json' }, body:body });
        },

          getUserSearchByQuery: async (queryString: string) => {
            const url = `/user/search${queryString}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        postUserAssignRoles: async (body: any) => {
            const url = `/user/assign-roles`;
            return apiFetch(url, { method: "POST", headers: { 'Content-Type': 'application/json' }, body:body });
        },

        postUserCheckOrCreate: async (body: any) => {
            const url = `/user/check-or-create-user`;
            return apiFetch(url, { method: "POST", headers: { 'Content-Type': 'application/json' }, body:body });
        },

         getApplicationEnvironmentsByIdpName: async (url: string) => {
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

         getApplicationEnvironmentsByAppCd: async (appCd: string) => {
            const url = `/application/${appCd}/environments`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        getApplicationEnvironmentsByUserIdpGuid: async (userIdpGuid: any) => {
            const url = `/application/internal-access/${userIdpGuid}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

         postCreateUser: async (body: any) => {
            const url = `/user/create-user`;
            return apiFetch(url, { method: "POST", headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }, body:body });
        },

         getNextUserNumber: async (userRoot: any) => {
            const url = `/user/next-user-number?root=${encodeURIComponent(userRoot)}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        getOrganizationsByType: async (organizationType: any) => {
            const url = `/organization/search?type=${encodeURIComponent(organizationType)}&fetchAll=true`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        getCheckUserByUsername: async (username: any) => {
            const url = `/user/check-username?username=${encodeURIComponent(username)}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } });
        },

        getCheckUserByEmail: async (email: any) => {
            const url = `/user/check-email?email=${encodeURIComponent(email)}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } });
        },

        getSendGridRedirect: async () => {
            const url = `/send-grid/redirect`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        getUserGroups: async (userId: any) => {
            const url = `/user/${userId}/groups`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        fetchUserRequests: async (userId: any) => {
            const url = `/user/${userId}/requests`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

         postResendVerificationEmail: async (userId: any) => {
            const url = `/user/${userId}/resend-verification`;
            return apiFetch(url, { method: "POST", headers: { 'Content-Type': 'application/json'} });
        },

         fetchRequestLifecycle: async (id: any) => {
            const url = `/request-lifecycle/${id}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

         postRevokeUserGroup: async (body: any) => {
            const url = `/user/group/revoke`;
            return apiFetch(url, { method: "POST", headers: { 'Content-Type': 'application/json'}, body:body });
        },

         fetchRequestHistoryByAssignedUser: async (assignedToUser: any) => {
            const url = `/request-history?assignedTo=${encodeURIComponent(assignedToUser)}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

         postApproveRequest: async (body: any) => {
            const url = `/request/approve`;
            return apiFetch(url, { method: "POST", headers: { 'Content-Type': 'application/json'}, body:body });
        },

         postUserWithRequests: async (body: any) => {
            const url = `/user/with-requests`;
            return apiFetch(url, { method: "POST", headers: { 'Content-Type': 'application/json'}, body:body });
        },

         fetchUserGroupsInternal: async (userId: any) => {
            const url = `/user/internal/${userId}/groups`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        fetchUserRequestsInternal: async (userId: any) => {
            const url = `/user/internal/${userId}/requests`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        postRevokeUserGroupInternal: async (body: any) => {
            const url = `/user/internal/group/revoke`;
            return apiFetch(url, { method: "POST", headers: { 'Content-Type': 'application/json'}, body:body });
        },

        fetchUserSearchGraph: async (queryString: any) => {
            const url = `/user/search-graph${`${queryString}`}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        searchUsersByApplicationCode: async (applicationCode: any, adminUserId: any) => {
            const url = `/user-app-request/search-by-app?applicationCode=${encodeURIComponent(applicationCode)}&adminUserId=${encodeURIComponent(adminUserId)}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        fetchAllApplications: async () => {
            const url = `/application/all`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },

        fetchAdminApplications: async (userIdentifier: any) => {
            const url = `/application/admin/${userIdentifier}`;
            return apiFetch(url, { method: "GET", headers: { 'Content-Type': 'application/json' } });
        },
        
    }

    return GetIdentityAppService;
}